import React from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import "./footer.css";

const Footer: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  // Footer menu links
  const menuLinks = [
    { label: "Features", url: "https://www.eximius.ai/#Features" },
    { label: "Why Eximius.ai", url: "https://www.eximius.ai/#whyEximius" },
    { label: "Contact", url: "https://www.eximius.ai/#Contact" },
  ];

  const policyLinks = [
    { label: "Privacy Policy", url: "https://www.eximius.ai/privacy-policy/" },
    {
      label: "Terms & Conditions",
      url: "https://www.eximius.ai/terms-conditions/",
    },
    // { label: "Cookie Policy", url: "https://www.eximius.ai/cookie-policy/" },
  ];

  const socialLinks = [
    { label: "LinkedIn", url: "" }, // https://www.linkedin.com/company/eximius-ai/
    { label: "Facebook", url: "" },
  ];

  // Navigation handler
  const handleNavigation = (url: string) => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <footer className="footer">
      <Container maxWidth="lg" className="containerFooter">
        <Grid container spacing={isMobile ? 3 : 2}>
          {/* Company Info Section */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Grid item xs={12} className="company-info">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mb: 2,
                  }}
                  onClick={() => handleNavigation("https://www.eximius.ai/")}
                >
                  <img
                    src="https://www.eximius.ai/wp-content/themes/eximius/assets/images/footer-logo.svg"
                    alt="Eximius.ai"
                    style={{ height: "37px" }}
                  />
                </Box>
                {/* Updated Address Section */}
                <address>
                  <small className="infotext">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "row", sm: "column" }, // One line for mobile, two lines for larger screens
                        justifyContent: { xs: "center", sm: "flex-start" }, // Center for mobile, left-aligned for larger screens
                        gap: 1,
                      }}
                    >
                      {/* First part of the address */}
                      <span>4390 US-1 North, Suite 308</span>

                      {/* Second part of the address */}
                      <span>Princeton, NJ 08540</span>
                    </Box>
                  </small>
                </address>

                <div className="email">
                  <a href="mailto:info@eximius.ai" className="infotext">
                    info@eximius.ai
                  </a>
                </div>
              </Grid>
            </Grid>
          </Grid>

          {/* Footer Menu Section */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box
              className="footer-menu-outer"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                gap: { xs: 3, sm: 2 },
              }}
            >
              {/* Menu Links */}
              <Grid container spacing={2}>
                <Grid item xs={4} className="footer-menu">
                  <h3 className="footerheading">Menu</h3>
                  <ul>
                    {menuLinks.map((item) => (
                      <li key={item.label}>
                        <a href={item.url} className="footerText">
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </Grid>

                {/* Policy Links */}
                <Grid item xs={4} className="footer-menu">
                  <h3 className="footerheading">Policy</h3>
                  <ul>
                    {policyLinks.map((item) => (
                      <li key={item.label}>
                        <a href={item.url} className="footerText">
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </Grid>

                {/* Social Links */}
                <Grid item xs={4} className="footer-menu">
                  <h3 className="footerheading">Social</h3>
                  <ul>
                    {socialLinks.map((item) => (
                      <li key={item.label}>
                        <a href={item.url} className="footerText">
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Footer Bottom Section */}
          <Grid item xs={12} >
            <Box
              className="footer-boot"
              sx={{
                borderTop: "1px solid rgba(255,255,255,0.1)",
                mt: { xs: 2, sm: 3 },
                pt: 2,
                textAlign: { xs: "center", sm: "left", md: "left", lg: "left" },
              }}
            >
              <div className="copy-right footerBottom">
                <p>© 2025 Copyright - Eximius.ai</p>
              </div>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

export default Footer;
